import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title } from 'common/components/layout';
import { getCartTitle } from 'common/helpers/miscHelper';
import { getCart } from 'redux/cart/actions';

import CartDisplay from './components/CartDisplay';
import Proceed from './components/Proceed';

class Cart extends Component {
  componentDidMount() {
    const { props } = this;
    props.getCart();
  }

  render() {
    const { settings, cart } = this.props;
    if (!settings.data || !cart.data) {
      return (
        <Layout title="Cart" showSideCart={false} loading>
          <Title>Cart</Title>
        </Layout>
      );
    }
    const title = getCartTitle(settings);
    return (
      <Layout title={title} showSideCart={false}>
        <Title>{title}</Title>

        <div>
          <div className="c7-cart__wrapper">
            {/*
            <p className="c7-message-warning">This is a test warning message</p>
            */}
            <div className="c7-cart__buttons--top">
              <Proceed
                cart={cart.data}
                showViewCart={false}
                settings={settings}
              />
            </div>
            <CartDisplay cart={cart.data} settings={settings} />
            <Proceed
              cart={cart.data}
              showViewCart={false}
              settings={settings}
            />
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  cart: state.cart,
  settings: state.setting
});

export default connect(mapStateToProps, {
  getCart
})(Cart);
